import { useVirtualizer } from '@tanstack/react-virtual';
import classNames from 'classnames/bind';
import React from 'react';

import styles from './TableBody.module.scss';
import TableBodyRow from './TableBodyRow';

const cx = classNames.bind(styles);

const TableBody = ({ table, tableContainerRef }) => {
  const { rows } = table.getRowModel();

  // https://tanstack.com/table/latest/docs/framework/react/examples/virtualized-rows
  const rowVirtualizer = useVirtualizer({
    count: rows.length,
    estimateSize: () => 33,
    getScrollElement: () => tableContainerRef.current,
    measureElement:
      typeof window !== 'undefined' && navigator.userAgent.indexOf('Firefox') === -1
        ? (element) => element?.getBoundingClientRect().height
        : undefined,
    overscan: 5,
  });

  return (
    <tbody style={{ height: `${rowVirtualizer.getTotalSize()}px` }} className={cx('container')}>
      {rowVirtualizer.getVirtualItems().map((virtualRow) => {
        const row = rows[virtualRow.index];

        return <TableBodyRow key={row.id} row={row} virtualRow={virtualRow} rowVirtualizer={rowVirtualizer} />;
      })}
    </tbody>
  );
};

export default TableBody;
